(function () {
  function initSidebarUpsell(root) {
    if (root.dataset.sidebarUpsellReady === 'true') return;
    root.dataset.sidebarUpsellReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sidebar-upsell-slide]'));
    if (slides.length <= 1) return;

    var prev = root.querySelector('[data-sidebar-upsell-prev]');
    var next = root.querySelector('[data-sidebar-upsell-next]');
    var current = root.querySelector('[data-sidebar-upsell-current]');
    var index = 0;

    function render(activeIndex) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('magio-pdp__sidebar-upsell-card--hidden', i !== activeIndex);
      });

      if (current) current.textContent = String(activeIndex + 1);
      if (prev) prev.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (index > 0) {
          index -= 1;
          render(index);
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        if (index < slides.length - 1) {
          index += 1;
          render(index);
        }
      });
    }

    render(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-magio-pdp-sidebar-upsell]').forEach(initSidebarUpsell);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches('[data-magio-pdp-sidebar-upsell]')) initSidebarUpsell(node);
        initAll(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
